// A dynamic zone is populated per component: `{ content: { on: { 'blog.figure': { image: true } } } }`
// becomes `populate[content][on][blog.figure][populate][image]=true`, and `true` for a component
// becomes `[populate]=*`.
export const toPopulateQuery = (populateObj) => {
  const parts = [];

  const walk = (obj, prefix = 'populate') => {
    Object.entries(obj).forEach(([key, value]) => {
      const base = `${prefix}[${key}]`;

      if (value === true || value === '*') {
        parts.push(`${base}=${value === true ? 'true' : '*'}`);
      } else if (value && typeof value === 'object' && value.on) {
        Object.entries(value.on).forEach(([component, componentValue]) => {
          const componentBase = `${base}[on][${component}]`;
          if (componentValue === true) {
            parts.push(`${componentBase}[populate]=*`);
          } else {
            walk(componentValue, `${componentBase}[populate]`);
          }
        });
      } else if (value && typeof value === 'object') {
        walk(value, `${base}[populate]`);
      }
    });
  };

  walk(populateObj);
  return parts.join('&');
};
